import { render, staticRenderFns } from "./ShouldUpgrade.vue?vue&type=template&id=32740708"
import script from "./ShouldUpgrade.vue?vue&type=script&lang=js"
export * from "./ShouldUpgrade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports